let moment = require('moment');
/**
 * @class walletService
 */
function WalletService($root, $q, $indexedDB, $log, walletBackend, localStorageService) {
    let self = this;

    /* --------------------------------------------------------------------------------------------------*/
    /*                                      BUSINESSFORM                                                  */
    /* --------------------------------------------------------------------------------------------------*/
    const BUSINESS_FORM_KEY = 'user.businessForm';
    const USERNETWORK_KEY_EXPIRATION = 'user.userNetwork.expirationDate';

    /**
     * Save locally the user network
     * @param  {Object} businessForm
     */
    function _saveBusinessFormLocally(businessForm) {
        localStorageService.set(BUSINESS_FORM_KEY, angular.toJson(businessForm));
    }

    /**
     * Get the locally saved orderForm
     * @return {Object}
     */
    self.getBusinessFormLocally = () => {
        let businessForm = localStorageService.get(BUSINESS_FORM_KEY);
        let expirationDate = localStorageService.get(USERNETWORK_KEY_EXPIRATION);

        expirationDate = expirationDate === '[]' ? null : expirationDate;
        businessForm = businessForm ? angular.fromJson(businessForm) : businessForm;

        return {
            businessForm: businessForm,
            expirationDate: expirationDate
        };
    };

    /**
     * Get order form
     * @return {Promise}
     */
    self.getBusinessForm = () => {
        let businessFormKeys = self.getBusinessFormLocally();
        businessFormKeys.businessForm = businessFormKeys.businessForm || [];
        if (
            !$root.online ||
            (businessFormKeys.businessForm.length &&
                businessFormKeys.expirationDate &&
                moment(businessFormKeys.expirationDate).isAfter(moment()))
        ) {
            $log.info('GET local business form');
            return $q.when(businessFormKeys.businessForm);
        }

        return walletBackend.getBusinessForm().then(function(businessForm) {
            _saveBusinessFormLocally(businessForm);
            return businessForm;
        });
    };

    self.clearCache = () => {
        localStorageService.set(BUSINESS_FORM_KEY, angular.toJson([]));

        return $indexedDB.openStore('Wallets', function(objectStore) {
            return objectStore.clear();
        });
    };

    /* --------------------------------------------------------------------------------------------------*/
    /*                                          WALLET                                                  */
    /* --------------------------------------------------------------------------------------------------*/
    self.sendCreateWallet = function(data) {
        return walletBackend.sendCreateWallet(data, $root.user).then(function(res) {
            return res;
        });
    };

    self.createBusiness = function(data) {
        return walletBackend.createBusiness(data).then(function(res) {
            return res;
        });
    };

    self.getStoreBusinesses = function(data) {
        return walletBackend.getStoreBusinesses(data).then(function(res) {
            return res;
        });
    };

    self.getBusinessById = function(data) {
        return walletBackend.getBusinessById(data).then(function(res) {
            return res;
        });
    };

    self.updateBusiness = function(business) {
        return walletBackend.updateBusiness(business).then(function(res) {
            return res;
        });
    };

    self.deleteBusiness = function(business) {
        return walletBackend.deleteBusiness(business).then(function(res) {
            return res;
        });
    };

    self.getAllBusinesses = function(filters) {
        return walletBackend.getAllBusinesses(filters).then(function(res) {
            return res;
        });
    };

    return self;
}

WalletService.$inject = ['$rootScope', '$q', '$indexedDB', '$log', 'walletBackend', 'localStorageService'];

angular.module('app.prospection.wallet.walletService', []).factory('walletService', WalletService);
